/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React from 'react';
const FieldSet = ({ children, label, isError, required }) => {
  return (
    <fieldset className={isError ? 'custom-fieldset-error' : 'custom-fieldset'}>
      <legend className="same-font-family">
        <span style={{ color: isError ? '#dc3545' : '' }}> {label}</span>
        <span className="mandatory"> {required ? '*' : ''}</span>
      </legend>
      {children}
    </fieldset>
  );
};

export default FieldSet;
